import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';

import { PromotionalEvents } from 'components/forYou/PromotionalEvents';
import { isMarketPromotion } from 'lib/promotionalEvent';

import type {
  MarketBannerQuery,
  MarketBannerQueryVariables,
} from './__generated__/index.graphql';

const MARKET_BANNER_QUERY = gql`
  query MarketBannerQuery($sport: Sport!) {
    tokens {
      promotionalEvents(sport: $sport) {
        slug
        ...PromotionalEvents_PromotionalEvent
      }
    }
  }
  ${PromotionalEvents.fragments.PromotionalEvent}
` as TypedDocumentNode<MarketBannerQuery, MarketBannerQueryVariables>;

export const MarketBanners = () => {
  const { sport } = useSportContext();
  const { data } = useQuery(MARKET_BANNER_QUERY, {
    variables: { sport },
  });

  const promotionalEvents =
    data?.tokens.promotionalEvents.filter(isMarketPromotion);
  if (promotionalEvents?.length) {
    return <PromotionalEvents promotionalEvents={promotionalEvents} />;
  }
  return null;
};
